import React from 'react';
import { Shield, Cookie, Eye, FileText, Users, Lock } from 'lucide-react';

const TermsAndConditions = () => {
  return (
    <div className="page-surface py-20 sm:py-24">
      <div className="max-w-4xl mx-auto px-5">
        <div className="mb-12 max-w-3xl">
          <p className="eyebrow">Informații legale</p>
          <h1 className="page-heading mt-5 font-bold">Termeni și condiții.</h1>
          <p className="mt-5 text-xl text-gray-600">Politici legale, confidențialitate și protecția datelor.</p>
        </div>

        {/* Politica de Confidențialitate */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <div className="flex items-center mb-6">
            <Shield className="h-8 w-8 text-blue-600 mr-4" />
            <h2 className="text-2xl font-bold">Politica de Confidențialitate</h2>
          </div>
          <div className="space-y-4 text-gray-700">
            <p>
              <strong>Centru Progres S.R.L.</strong> respectă confidențialitatea datelor personale și se angajează să protejeze informațiile pe care ni le furnizați.
            </p>
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Ce date colectăm:</h3>
            <ul className="space-y-2 ml-4">
              <li>• Numele și prenumele</li>
              <li>• Adresa de email</li>
              <li>• Numărul de telefon</li>
              <li>• Informații despre cursurile de interes</li>
            </ul>
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Cum folosim datele:</h3>
            <ul className="space-y-2 ml-4">
              <li>• Pentru a vă contacta în legătură cu cursurile</li>
              <li>• Pentru a vă informa despre ofertele noastre</li>
              <li>• Pentru a îmbunătăți serviciile noastre</li>
            </ul>
          </div>
        </div>

        {/* Politica Cookie-uri */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <div className="flex items-center mb-6">
            <Cookie className="h-8 w-8 text-blue-600 mr-4" />
            <h2 className="text-2xl font-bold">Politica Cookie-uri</h2>
          </div>
          <div className="space-y-4 text-gray-700">
            <p>
              Site-ul nostru utilizează cookie-uri pentru a îmbunătăți experiența utilizatorilor și pentru a analiza traficul.
            </p>
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Tipuri de cookie-uri:</h3>
            <ul className="space-y-2 ml-4">
              <li>• <strong>Cookie-uri esențiale:</strong> Necesare pentru funcționarea site-ului</li>
              <li>• <strong>Cookie-uri de analiză:</strong> Google Analytics pentru înțelegerea traficului</li>
              <li>• <strong>Cookie-uri de marketing:</strong> Google Ads pentru promovare</li>
              <li>• <strong>Cookie-uri de preferințe:</strong> Pentru a reține setările dvs.</li>
            </ul>
            <p className="mt-4">
              Puteți gestiona preferințele cookie-urilor prin banner-ul de consimțământ care apare la prima vizită.
            </p>
          </div>
        </div>

        {/* GDPR și Drepturile Utilizatorilor */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <div className="flex items-center mb-6">
            <Eye className="h-8 w-8 text-blue-600 mr-4" />
            <h2 className="text-2xl font-bold">GDPR și Drepturile Dvs.</h2>
          </div>
          <div className="space-y-4 text-gray-700">
            <p>
              În conformitate cu Regulamentul General privind Protecția Datelor (GDPR), aveți următoarele drepturi:
            </p>
            <ul className="space-y-2 ml-4">
              <li>• <strong>Dreptul de acces:</strong> Să solicitați informații despre datele procesate</li>
              <li>• <strong>Dreptul de rectificare:</strong> Să corectați datele inexacte</li>
              <li>• <strong>Dreptul de ștergere:</strong> Să solicitați ștergerea datelor personale</li>
              <li>• <strong>Dreptul de restricționare:</strong> Să limitați procesarea datelor</li>
              <li>• <strong>Dreptul la portabilitate:</strong> Să solicitați datele în format portabil</li>
              <li>• <strong>Dreptul de opoziție:</strong> Să vă opuneți procesării datelor</li>
            </ul>
            <p className="mt-4">
              Pentru exercitarea acestor drepturi, ne puteți contacta la: <strong>contact@centrulprogres.com</strong>
            </p>
          </div>
        </div>

        {/* Securitatea Datelor */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <div className="flex items-center mb-6">
            <Lock className="h-8 w-8 text-blue-600 mr-4" />
            <h2 className="text-2xl font-bold">Securitatea Datelor</h2>
          </div>
          <div className="space-y-4 text-gray-700">
            <p>
              Implementăm măsuri de securitate tehnice și organizatorice pentru a proteja datele personale împotriva:
            </p>
            <ul className="space-y-2 ml-4">
              <li>• Accesului neautorizat</li>
              <li>• Modificării neautorizate</li>
              <li>• Divulgării accidentale</li>
              <li>• Distrugerii accidentale</li>
            </ul>
          </div>
        </div>

        {/* Servicii Terțe */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <div className="flex items-center mb-6">
            <Users className="h-8 w-8 text-blue-600 mr-4" />
            <h2 className="text-2xl font-bold">Servicii Terțe</h2>
          </div>
          <div className="space-y-4 text-gray-700">
            <p>Site-ul nostru folosește următoarele servicii terțe:</p>
            <ul className="space-y-2 ml-4">
              <li>• <strong>Google Analytics:</strong> Pentru analiza traficului site-ului</li>
              <li>• <strong>Google Ads:</strong> Pentru campanii de marketing</li>
              <li>• <strong>Vercel:</strong> Pentru hosting-ul site-ului</li>
            </ul>
            <p className="mt-4">
              Aceste servicii au propriile politici de confidențialitate pe care vă încurajăm să le consultați.
            </p>
          </div>
        </div>

        {/* Contact și Modificări */}
        <div className="bg-white rounded-lg shadow-md p-8">
          <div className="flex items-center mb-6">
            <FileText className="h-8 w-8 text-blue-600 mr-4" />
            <h2 className="text-2xl font-bold">Contact și Modificări</h2>
          </div>
          <div className="space-y-4 text-gray-700">
            <h3 className="text-lg font-semibold text-gray-900">Informații Legale ale Operatorului:</h3>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="mb-2">
                <strong>Denumirea societății:</strong> Centru Progres S.R.L.
              </p>
              <p className="mb-2">
                <strong>Cod Unic de Înregistrare (CUI):</strong> 51396650
              </p>
              <p className="mb-2">
                <strong>Număr de ordine în Registrul Comerțului:</strong> J40/19206/2023
              </p>
              <p className="mb-2">
                <strong>Sediul social:</strong> Petrichioaia, Ilfov, România
              </p>
              <p className="mb-2">
                <strong>Adresa operațională:</strong> Șoseaua Colentina nr. 16, Complex Rose Garden, Bloc B4, parter, București, România
              </p>
              <p className="mb-2">
                <strong>Cod CAEN principal:</strong> 8559 - Alte forme de învățământ n.c.a.
              </p>
            </div>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Date de Contact:</h3>
            <p>
              <strong>Email:</strong> contact@centrulprogres.com<br />
              <strong>Telefon:</strong> 0726 423 784 / 0723 696 188<br />
              <strong>Website:</strong> www.centrulprogres.com
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Responsabil cu Protecția Datelor:</h3>
            <p>
              Pentru exercitarea drepturilor GDPR și pentru orice întrebări legate de prelucrarea datelor personale, 
              ne puteți contacta la adresa de email: <strong>contact@centrulprogres.com</strong>
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Modificări ale Termenilor și Condițiilor:</h3>
            <p>
              Ne rezervăm dreptul de a modifica acești termeni și condiții. Modificările vor fi publicate pe această pagină 
              și vor intra în vigoare imediat după publicare. Utilizatorii vor fi notificați prin email despre modificări importante.
            </p>
            
            <p className="mt-4 text-sm text-gray-600 bg-gray-50 p-3 rounded">
              <strong>Ultima actualizare:</strong> {new Date().toLocaleDateString('ro-RO')}<br />
              <strong>Versiunea documentului:</strong> 1.0
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
